import { Suspense } from "react";
import { usePersonWithCockpitId } from "../../hooks/SettingsHooks";
import { useUser } from "../../functional-components/UserContext";
import Icon from "../Icon";
import "./style.scss";
import { unwrapAsset } from "../../utils/CockpitUtils";

const PeopleItemInner = ({ id, name }) => {
  const person = usePersonWithCockpitId(id);
  const { admin } = useUser();
  if (person?.image) person.image = unwrapAsset(person.image);
  //console.log("person", person);

  return (
    <div className="contact-person">
      {person?.image ? (
        <img
          className="contact-image"
          src={person?.image?.styles?.preview || person?.image?.path}
          alt={person?.name}
        />
      ) : (
        <div className="contact-image">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192.779 198.473">
            <g id="c" data-name="Layer 1">
              <g>
                <rect
                  x="29.877"
                  y="47.108"
                  width="76.987"
                  height="14.088"
                  transform="translate(-18.265 64.208) rotate(-45.001)"
                  fill="#3d3e3e"
                  strokeWidth="0"
                />
                <rect
                  x="29.877"
                  y="70.09"
                  width="76.987"
                  height="14.087"
                  transform="translate(-34.516 70.94) rotate(-45.001)"
                  fill="#3d3e3e"
                  strokeWidth="0"
                />
                <rect
                  x="29.877"
                  y="93.072"
                  width="76.987"
                  height="14.087"
                  transform="translate(-50.767 77.672) rotate(-45.001)"
                  fill="#3d3e3e"
                  strokeWidth="0"
                />
                <rect
                  x="117.464"
                  y="4.189"
                  width="14.087"
                  height="76.987"
                  transform="translate(6.287 100.544) rotate(-45.001)"
                  fill="#3d3e3e"
                  strokeWidth="0"
                />
                <rect
                  x="117.464"
                  y="27.171"
                  width="14.087"
                  height="76.987"
                  transform="translate(-9.964 107.276) rotate(-45.001)"
                  fill="#3d3e3e"
                  strokeWidth="0"
                />
                <rect
                  x="117.464"
                  y="50.153"
                  width="14.087"
                  height="76.987"
                  transform="translate(-26.214 114.011) rotate(-45.003)"
                  fill="#3d3e3e"
                  strokeWidth="0"
                />
                <rect
                  x="162.904"
                  y="65.601"
                  width="20.211"
                  height="59.449"
                  rx="6.854"
                  ry="6.854"
                  fill="#3d3e3e"
                  strokeWidth="0"
                />
                <rect
                  x="9.691"
                  y="65.601"
                  width="20.21"
                  height="59.449"
                  rx="6.854"
                  ry="6.854"
                  fill="#3d3e3e"
                  strokeWidth="0"
                />
                <path
                  d="M173.108,73.608c0-20.244-8.287-38.658-21.62-51.988C138.157,8.287,119.743,0,99.5,0h-6.325c-20.244,0-38.658,8.287-51.988,21.62-13.334,13.33-21.621,31.744-21.62,51.988h5c0-18.865,7.713-36.006,20.156-48.452,12.447-12.443,29.587-20.155,48.452-20.156h6.325c18.865,0,36.006,7.713,48.452,20.156,12.443,12.447,20.155,29.587,20.156,48.452h5,0Z"
                  fill="#3d3e3e"
                  strokeWidth="0"
                />
                <polygon
                  points="6.531 79.849 6.531 112.812 0 106.281 0 84.722 6.531 79.849"
                  fill="#3d3e3e"
                  strokeWidth="0"
                />
                <polygon
                  points="186.248 112.812 186.248 79.849 192.779 86.38 192.779 107.939 186.248 112.812"
                  fill="#3d3e3e"
                  strokeWidth="0"
                />
                <path
                  d="M168.16,118.628c0,18.865-7.713,36.006-20.156,48.453-8.099,8.097-18.195,14.165-29.453,17.428v5.21c12.648-3.396,23.98-10.093,32.988-19.103,13.334-13.33,21.621-31.744,21.62-51.988h-5Z"
                  fill="#3d3e3e"
                  strokeWidth="0"
                />
              </g>
              <circle
                cx="124.507"
                cy="185.67"
                r="12.803"
                fill="#3d3e3e"
                strokeWidth="0"
              />
            </g>
          </svg>
        </div>
      )}
      <h4 className="contact-name">
        {person?.name || name || "Contact Bjelin"}
      </h4>
      <div className="contact-title">
        {admin && !person ? "Error fetching person data" : person?.title || ""}
      </div>
      <div className="contact-email">
        <a href={"mailto:" + person?.email || "info@bjelin.com"}>
          {person?.email || "info@bjelin.com"}
        </a>
      </div>
      {person?.phone && (
        <div className="contact-phone">
          <a href={"tel:" + person.phone}>{person.phone}</a>
        </div>
      )}
    </div>
  );
};

const PeopleItem = ({ id, name, style = {}, showPrefix = false }) => {
  return (
    <Suspense fallback={<Icon name="spinner" className="fa-pulse" />}>
      <PeopleItemInner
        id={id}
        name={name}
        style={style}
        showPrefix={showPrefix}
      />
    </Suspense>
  );
};

export default PeopleItem;
